import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { PriceStore } from '../../store/price.store';
import { UtilityService } from '../services/utility.service';

export const priceDashboardResolver: ResolveFn<boolean> = async (route, state) => {
  const store = inject(PriceStore);
  const router = inject(Router);
  const utility = inject(UtilityService);
  if (!store.isPriceComponentsInitialized()) {
    store.getPreRequisiteForPriceList();
  }

  await utility.checkPreRequisites(
    () =>
      !!store.priceComponents().length ||
      store.isPriceComponentsInitialized() ||
      store.isRolesInitialized() ||
      !!store.roles().length
  );
  if (!store.priceComponents().length && !store.roles().length) {
    router.navigate(['/no-records']);
    return false;
  }

  return true;
};
